export default __webpack_public_path__ + "static/media/logo.67504d6d.png";